import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatDate = (date) => {
  if (!date || isNaN(new Date(date).getTime())) return 'Por definir';
  return new Date(date).toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('es-EC', {
    style: 'currency',
    currency: 'USD'
  }).format(amount);
};

export const formatDateTime = (date) => {
  if (!date || isNaN(new Date(date).getTime())) return 'Por definir';
  return new Date(date).toLocaleString('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Normaliza cualquier URL de imagen/media para que funcione correctamente.
 * Maneja: rutas relativas /uploads/..., /api/uploads/..., URLs absolutas viejas con host incorrecto,
 * URLs externas (Google Drive, etc), y data: URIs.
 */
export const getMediaUrl = (url) => {
  if (!url) return '';
  if (typeof url !== 'string') return url;
  if (url.startsWith('data:')) return url;

  // Si contiene /uploads/, extraer la parte relativa y construir URL correcta
  if (url.includes('/uploads/')) {
    const relativePart = url.split('/uploads/')[1];
    return `${BACKEND_URL}/api/uploads/${relativePart}`;
  }

  // URL externa (Google Drive, CDN, etc.)
  if (url.startsWith('http')) return url;

  // Cualquier otra ruta relativa
  return `${BACKEND_URL}${url}`;
};
